import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Table } from 'reactstrap';
import { useIntl } from 'react-intl';

import AdminMetadataGroupListHeader from '../MetadataGroupListHeader';
import AdminTaxonomiesListHeader from './ListHeader';
import AdminTaxonomiesListItem from './ListItem';

const AdminTaxonomiesList = ({
  ai,
  metadataGroup,
  taxonomies,
  deleteTaxonomyFromList,
  moveCustomCategory,
  saveCustomCategories,
}) => {
  const intl = useIntl();
  const [dragging, setDragging] = useState(false);
  const [collapseOpen, setCollapseOpen] = useState(true);

  return (
    <div className="table-wrapper">
      <Table className="users-list taxonomies-list" responsive>
        {metadataGroup && (
          <thead className={classnames('master-header', { 'master-header-content-collapsed': !collapseOpen })}>
            <AdminMetadataGroupListHeader
              metadataGroup={metadataGroup}
              collapseOpen={collapseOpen}
              handleCollapseOpen={setCollapseOpen}
              scope="taxonomies"
            />
          </thead>
        )}
        {collapseOpen && (
          <>
            <thead>
              <AdminTaxonomiesListHeader />
            </thead>
            <tbody className={classnames({ dragging, 'no-grab': ai })}>
              {taxonomies.map((taxonomy) => (
                <AdminTaxonomiesListItem
                  ai={ai}
                  key={taxonomy.id}
                  index={taxonomy.id}
                  taxonomy={taxonomy}
                  deleteTaxonomyFromList={deleteTaxonomyFromList}
                  canDrag={!ai}
                  setDragging={setDragging}
                  moveCustomCategory={moveCustomCategory}
                  saveCustomCategories={saveCustomCategories}
                />
              ))}
              {(metadataGroup && taxonomies.length === 0) && (
                <tr>
                  <th scope="row" colSpan={6} className="nothing-found-table">
                    {intl.formatMessage({ defaultMessage: 'No Tag Categories assigned to this Group' })}
                  </th>
                </tr>
              )}
            </tbody>
          </>
        )}
      </Table>
    </div>
  );
};

AdminTaxonomiesList.propTypes = {
  metadataGroup: PropTypes.object,
  taxonomies: PropTypes.array.isRequired,
  deleteTaxonomyFromList: PropTypes.func.isRequired,
  moveCustomCategory: PropTypes.func.isRequired,
  saveCustomCategories: PropTypes.func.isRequired,
  ai: PropTypes.bool,
};

AdminTaxonomiesList.defaultProps = {
  metadataGroup: null,
  ai: false,
};

export default AdminTaxonomiesList;
